const round = (price) => {
  return Math.round((price + 0.00001) * 100) / 100
}

const getPriceExclTax = (price, taxPercent, rounding) => {
  // Price = 10 / 1.21 = 8.26....
  const result = price / ((taxPercent / 100) + 1)

  if (rounding) {
    // Round to 2 decimals, so 1.8766666 becomes 1.88
    return round(result)
  } else {
    return result
  }
}

/*
  * Get a price with tax calculation. If self.pricesInclTax is true, it will
  * return the price incl. tax, otherwise it will return the price excl. tax.
  *
  * When tax calculation V2 is enabled, it will do a different calculation.
  * If self.fromEu is true, it will return the price incl. tax, otherwise excl. tax.
  *
  * You can also enable forceTaxCalculation as parameter, it will always return
  * the price incl. tax.
  */
const getPriceInclTax = (price, forceTaxCalculation, taxPercent, fromEu, rounding) => {
  if (taxPercent && taxPercent !== undefined) {
    let result = 0

    if (fromEu || forceTaxCalculation) {
      result = price * (1 + (taxPercent / 100))
    } else {
      result = price
    }

    if (rounding) {
      // Round to 2 decimals, so 1.8766666 becomes 1.88
      return round(result)
    } else {
      return result
    }
  }

  return price
}

const checkIfShippingIsFree = (shippingcosts, pricetable, minimalAmountForFreeShipping) => {
  if (minimalAmountForFreeShipping > 0) {
    if (shippingcosts || (pricetable.shipping && !pricetable.shipping.calculated)) {
      const amount = round(pricetable.fromEu ? pricetable.subtotalIncl : pricetable.subtotalExcl)
      if (amount >= minimalAmountForFreeShipping) {
        return true
      }
    }
  }

  return false
}

export { round, getPriceExclTax, getPriceInclTax, checkIfShippingIsFree }
